import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcParcelComponent — parcel/envelope-style icon for PGTS/RTO parcel tabs.
 */
@Component({
  selector: 'ic-parcel',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-parcel.html',
})
export class IcParcelComponent {
  @Input() startColor: string | null = null;
  @Input() endColor: string | null = null;
  @Input() opacity = 1;
  @Input() width: number | string = 14;
  @Input() height: number | string = 16;
  @Input() color = '';
  @Input() defaultColor = '#B8C0C6';

  gradientId = `parcelGradient-${Math.random().toString(36).slice(2)}`;

  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
